import { render } from "./SApage.vue?vue&type=template&id=b51e44e2&scoped=true"
import script from "./SApage.vue?vue&type=script&lang=js"
export * from "./SApage.vue?vue&type=script&lang=js"

import "./SApage.css?vue&type=style&index=0&id=b51e44e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b51e44e2"]])

export default __exports__